// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3HwBp","insightsList":"newBusinessInsightsMenu_insightsList__VOk5-","active":"newBusinessInsightsMenu_active__2ZXdD"};